const $body = $('body')
const $filter = $('.js-filter')
const $filterButton = $('button.js-filterToggle')
const $filterCircleButton = $('.js-filterCircleButton')
const $filterButtonTitle = $('.js-filterToggleTitle')
const $filterSelect = $('.js-filterSelectLink')
const $filterClear = $('.js-filterClear')
const $filterClose = $('.js-filterClose')
const filterPlaceholder = $filterButton.data('title')

$('.js-filterToggle').on('click', () => {
  $filter.addClass('is_open')
  setTimeout(() => {
    $body.addClass('is-filter-open')
  }, 33)
})

$filterClose.on('click', (e) => {
  e.preventDefault()
  $body.removeClass('is-filter-open')

  setTimeout(() => {
    $filter.removeClass('is_open')
  }, 700)
})

$('.js-filterRadios input[type="radio"]').on('change', (e) => {
  const valueText = $(e.currentTarget).next().text()

  $filterButtonTitle.text(valueText)
  $filterButton
    .removeClass('button_theme_blue_border')
    .addClass('button_theme_blue')

  $filterClose.trigger('click')

  visibleClearButton()
})

$filterClear.on('click', (e) => {
  e.preventDefault()

  $filterButtonTitle.text(filterPlaceholder)

  $filterButton
    .removeClass('button_theme_blue')
    .addClass('button_theme_blue_border')

  $filterClose.trigger('click')

  hideClearButton()
})

$filterSelect.on('change', (e) => {
  const val = $(e.currentTarget).val()

  window.location.href = val
})

$(window).on('scroll load', filterScrollVisible)

function filterScrollVisible() {
  const scrolled = $(window).scrollTop()
  const vh = $(window).height()

  if (scrolled > vh) {
    $filterCircleButton.addClass('is_visible')
  } else {
    $filterCircleButton.removeClass('is_visible')
  }
}

function visibleClearButton() {
  $filterClear.removeClass('is_hidden')
  $filterCircleButton.addClass('is_active_filter')
}

function hideClearButton() {
  $filterClear.addClass('is_hidden')
  $filterCircleButton.removeClass('is_active_filter')
  $('.js-filterRadios input[type="radio"]').eq(0).prop('checked', true)
}

